import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "42",
  height: "42"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m17.643 30.118 14.925-14.924-1.651-1.652-13.274 13.273-6.65-6.65-1.65 1.652zM21.008 42q-4.356 0-8.191-1.653-3.834-1.653-6.671-4.487t-4.491-6.665Q0 25.363 0 21.008q0-4.356 1.653-8.191Q3.306 8.983 6.14 6.146t6.665-4.491Q16.637 0 20.992 0q4.356 0 8.191 1.653 3.834 1.653 6.671 4.487t4.491 6.665Q42 16.637 42 20.992q0 4.356-1.653 8.191-1.653 3.834-4.487 6.671t-6.665 4.491Q25.363 42 21.008 42"
    }, null, -1)
  ])))
}
export default { render: render }